import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

export const getReviewFeedback = (projectVersionId) => {
  const url = `${API_ROOT}/reviewer/${projectVersionId}/proposal/review/feedback`
  return doGet(url)
}

export const saveReviewFeedback = (projectVersionId, request) => {
  const url = `${API_ROOT}/reviewer/${projectVersionId}/proposal/review/submit/feedback`
  return doPost(url, request)
}

export const getReviewerFeedback = (projectVersionId) => {
  const url = `${API_ROOT}/reviewer/${projectVersionId}/proposal/reviewer/feedback`
  return doGet(url)
}
export const saveReviewerFeedback = (projectVersionId, request) => {
  const url = `${API_ROOT}/reviewer/${projectVersionId}/proposal/reviewer/submit/feedback`
  return doPost(url, request)
}
